import styled from 'styled-components';
import { useRouterContext } from '@/shared/router';
import { PageLayoutHeaderGoBackBtn } from '@/widgets/page-layout';

export const ProfilePageHeader = () => {
  const { dashboardGoBackLink } = useRouterContext();

  return (
    <HeaderWrapper>
      <PageLayoutHeaderGoBackBtn
        path={dashboardGoBackLink}
        label="Go back to dashboard"
      />
    </HeaderWrapper>
  );
};

const HeaderWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
